import { getLocalDateFromTimezone } from '@tradingblock/api';
import { ResponsiveTd } from '@tradingblock/components';
import { GroupedApplicationErrorSubRow } from '@tradingblock/types';
import React from 'react';

export interface ApplicationErrorsSubRowProps {
  subRows: GroupedApplicationErrorSubRow[];
}

export default function ApplicationErrorsSubRow({ subRows }: ApplicationErrorsSubRowProps) {
  return (
    <>
      {subRows.map((subRow, index) => (
        <tr
          key={index}
          style={{
            backgroundColor: 'rgb(12, 29, 63)',
          }}
        >
          <ResponsiveTd header="Error"></ResponsiveTd>
          <ResponsiveTd header="Count"></ResponsiveTd>
          <ResponsiveTd header="Most Recent Occurrence">
            {getLocalDateFromTimezone(new Date(subRow.timeStamp)).format('MM/DD/YY h:mm:ss A')}
          </ResponsiveTd>
          <ResponsiveTd header="Username">{subRow.ownerUsername}</ResponsiveTd>
        </tr>
      ))}
    </>
  );
}
